module.exports = __webpack_public_path__ + "static/media/foodworks_horizontal.bd2def9b.png";